var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrenchBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "#73D1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.847 163H175L104.51 13H80.5093V14.1515C87.7025 18.6651 88.2182 24.9102 83.883 35.4168L25 163H41.2656L60.9224 118.066H131.911L151.847 163ZM65.9093 106.038L95.8739 37.684L126.299 106.038H65.9093Z",
    fill: "white",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.723 67.3903C148.363 66.2949 147.499 65.4402 146.399 65.0945C145.297 64.7453 144.1 64.9516 143.18 65.644L133.266 73.0804L127.005 66.8205L134.277 56.7749C134.946 55.8524 135.134 54.6676 134.785 53.5829C134.437 52.4994 133.593 51.6459 132.512 51.2859C123.53 48.2929 113.389 50.6889 106.665 57.4126C101.052 63.1044 98.6284 70.7532 99.3907 78.0917L54.713 122.771C51.6735 125.809 50 129.84 50 134.119C50 138.399 51.6735 142.43 54.713 145.467C57.8417 148.596 61.9504 150.161 66.0614 150.161C70.17 150.161 74.2822 148.597 77.4097 145.467L122.284 100.594C123.084 100.669 123.888 100.706 124.691 100.706C131.197 100.706 137.689 98.2448 142.61 93.3221C142.617 93.3137 142.627 93.3055 142.635 93.2971C149.377 86.4196 151.71 76.4931 148.723 67.3903ZM59.7691 127.827L101.562 86.0323C102.787 88.6904 104.5 91.1719 106.7 93.3412C108.955 95.5644 111.524 97.2844 114.264 98.5009L72.3536 140.411C68.8827 143.88 63.2377 143.88 59.7691 140.411C58.0814 138.724 57.1517 136.489 57.1517 134.119C57.1517 131.751 58.0814 129.516 59.7691 127.827ZM137.541 88.2802C130.473 95.3328 118.893 95.3221 111.721 88.2491C104.615 81.2418 104.631 69.6608 111.739 62.4519C115.173 59.0191 119.861 57.1608 124.605 57.1608C124.791 57.1608 124.978 57.1632 125.163 57.1716L119.425 65.0992C118.395 66.5225 118.551 68.4831 119.793 69.7251L130.401 80.3334C131.659 81.5897 133.653 81.7329 135.075 80.6649L142.84 74.841C142.98 79.7637 141.124 84.6173 137.541 88.2802ZM62.7252 129.773C64.7514 127.747 67.9696 127.747 69.996 129.773C72.0222 131.8 72.0222 135.018 69.996 137.044C69.0425 138.236 67.7313 138.713 66.4202 138.713C65.109 138.713 63.7979 138.236 62.7252 137.163C61.7717 136.21 61.1758 134.899 61.1758 133.468C61.1758 132.038 61.6525 130.846 62.7252 129.773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(50 50)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchBlueBg);
export default __webpack_public_path__ + "static/media/wrench-blue-bg.74272fcc314e21db274e141cb1432c44.svg";
export { ForwardRef as ReactComponent };